
import UIOnboardingThumbIcon from '@/components/ui/icons/OnboardingThumbIcon.vue';
import UIOnboardingHandIcon from '@/components/ui/icons/OnboardingHandIcon.vue';
import UIOnboardingCommentIcon from '@/components/ui/icons/OnboardingCommentIcon.vue';
export default {
  name: 'UILegalDisclaimer',
  components: {
    UIOnboardingThumbIcon,
    UIOnboardingHandIcon,
    UIOnboardingCommentIcon,
  },
};
